import { useParams, Navigate } from 'react-router-dom';
import { useEffect } from 'react';

const ProjectViewRedirect = () => {
  const { organizationSlug, projectKey } = useParams();
  
  // One-time migration to clean up old localStorage structure
  useEffect(() => {
    try {
      const oldProject = localStorage.getItem('project');
      if (oldProject) {
        localStorage.removeItem('project');
      }
    } catch (error) {
      console.error('Error during localStorage migration:', error);
    }
  }, []);
  
  // Get stored project settings from localStorage
  const getStoredView = () => {
    try {
      // Check if we have settings for this specific project
      const allProjects = JSON.parse(localStorage.getItem('projects')) || {};
      const projectSettings = allProjects[projectKey];
      
      if (projectSettings && projectSettings.view) {
        return projectSettings.view;
      }
    } catch (error) {
      console.error('Error reading project settings from localStorage:', error);
    }
    // Default to 'board' view if no stored preference
    return 'board';
  };

  const view = getStoredView();
  
  return <Navigate to={`/${organizationSlug}/plan/${projectKey}/${view}`} replace />;
};

export default ProjectViewRedirect; 